

import ConfigScene from './ConfigScene';

class InteractiveManager {
  constructor() {
    // const
    this.MOVE_EASE = 0.09;

    // cursor
    this.isPointer = false;

    // stage position - not scaled
    this.stage = {
      x: 0,
      y: 0,
    };
    // stage percentage position - 0-1
    this.stageRatioBase = {
      x: ConfigScene.INIT_POS_X,
      y: ConfigScene.INIT_POS_Y,
    };
    // stage percentage position - 0-1 - eased
    this.stageRatio = {
      x: ConfigScene.INIT_POS_X,
      y: ConfigScene.INIT_POS_Y,
      half: {
        x: ConfigScene.INIT_POS_X - 0.5,
        y: ConfigScene.INIT_POS_Y - 0.5,
      },
    };

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    aScene.pixi.stage.interactive = true;

    aScene.pixi.stage.on('mousemove', () => {
      aPage.features.isMouse = true;
    });

    aScene.pixi.stage.on('touchstart', (e) => {
      aPage.features.isMouse = false;
      aScene.itemsHelper.hitEnabled = true;
      this.tMove(e);
    });

    aScene.pixi.stage.on('pointerup', () => {
      aScene.itemsHelper.trySelectItem();
    });

    aScene.pixi.stage.on('pointermove', (e) => {
      aScene.itemsHelper.hitEnabled = true;
      this.pMove(e);
    });
  }

  // --------------------------------------------------------------
  // Move
  // --------------------------------------------------------------

  pMove(e) {
    this.stage.x = e.data.global.x;
    this.stage.y = e.data.global.y;
    this.moveShared();
  }

  tMove(e) {
    this.stage.x = e.data.originalEvent.touches[0].clientX - aPage.resizer.canvasSide;
    this.stage.y = e.data.originalEvent.touches[0].clientY - aPage.resizer.canvasTop;
    this.moveShared();
  }

  moveShared() {
    this.stageRatioBase.x = Math.min(Math.max(this.stage.x / aPage.resizer.canvasW, 0), 1);
    this.stageRatioBase.y = Math.min(Math.max(this.stage.y / aPage.resizer.canvasH, 0), 1);
  }

  // --------------------------------------------------------------
  // Cursor
  // --------------------------------------------------------------

  setPointerCursor(doSet) {
    if (doSet && !this.isPointer) {
      this.isPointer = true;
      document.body.style.cursor = 'pointer';
    } else if (!doSet && this.isPointer) {
      this.isPointer = false;
      document.body.style.cursor = 'default';
    }
  }

  // --------------------------------------------------------------
  // Loop - ease
  // --------------------------------------------------------------

  easePosition() {
    this.stageRatio.x += (this.stageRatioBase.x - this.stageRatio.x) * this.MOVE_EASE;
    this.stageRatio.y += (this.stageRatioBase.y - this.stageRatio.y) * this.MOVE_EASE;
    this.stageRatio.half.x = this.stageRatio.x - 0.5;
    this.stageRatio.half.y = this.stageRatio.y - 0.5;
  }
}

export default InteractiveManager;



// WEBPACK FOOTER //
// ./src/js/scene/helpers/InteractiveManager.js